import React from 'react';
import { formatCurrency } from '../../../../lib/utils/formatters';
import { fromISO } from '../../../../lib/utils/datetime_formatters';

export default function SecondarySlide({ product, entity, merchant, order }) {
  const isPaymentPlan = order?.product_type !== 'mambu_loan';
  const lastAutoPayment = isPaymentPlan
    ? product?.last_payment_attempted_at?.replace(' ', 'T')
    : product?.last_auto_payment_try_date;

  return (
    <div className="flex justify-between items-start capitalize">
      <div className="mx-4">
        <p>merchant order ID: {order?.merchant_order_id}</p>
        <p>merchant customer ID: {!order?.merchant_customer_id && 'N/A'}</p>
        <p>{order?.merchant_customer_id}</p>
        <p>merchant type: {merchant?.type}</p>
        <p>
          last autopayment date:{' '}
          {lastAutoPayment ? fromISO(lastAutoPayment).toLocaleString() : 'N/A'}
        </p>
      </div>
      <div className="mx-4">
        <p>
          decline charge attempts:{' '}
          {isPaymentPlan ? product?.nsf_count : product?.declined_charge_attempts}
        </p>
        <p>
          credit line approval date:{' '}
          {entity?.latest_approval_date
            ? fromISO(entity?.latest_approval_date).toLocaleString()
            : 'N/A'}
        </p>
        <p>applicant fico: {entity?.applicant_fico_score}</p>
        <p>
          credit tier:{' '}
          {entity?.tier.includes('_')
            ? entity?.tier.replace('_', ' ')
            : entity?.tier}
        </p>
       {order?.entity_type === 'company' && <p>company GAR: {formatCurrency(entity?.gross_annual_revenue)}</p>}
      </div>
      <div className="mx-4">
        <p className="capitalize">
          Transaction Type:{' '}
          {order?.transaction_type === 'cka' ? 'CKA' : order?.transaction_type}
        </p>
        {order?.entity_type === 'company' &&<p>State/Region: {entity?.address.state}</p>}
        <p>shipping address:</p>
        {(!order?.shipping_address || !order?.shipping_address?.address1) ? 'Not Provided' : (
          <>
            <p>{order?.shipping_address.address1}</p>
            <p>{order?.shipping_address.address2}</p>
            <p>
              {order?.shipping_address.city}, {order?.shipping_address.state}{' '}
              {order?.shipping_address?.zip.substring(0, 5)}
            </p>
          </>
        )}
      </div>
    </div>
  );
}